import React from "react";
import styled from "styled-components";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import src_video from "../assets/solar_aidd.mp4";
import { Helmet } from "react-helmet";

export default function Help () {
    const links = [
        { name: "Home", link: "/landing" , isActive: false},        
        { name: "Upload new images", link: "/upload", isActive:false },
        { name: "View analysis", link: "/resultsHighLevel", isActive:false },
        { name: "About", link: "/about", isActive: false},
        { name: "Help", link: "/help", isActive: true}
        // { name: "Contact us", link: "/contactUs", isActive:false },
    ];

return (
    <Container>
        <Helmet>
            <title>Help | SolarAIDD</title>
            <meta name="description" content="Step-by-step guides for EL image uploads, batch processing, and interpreting AI defect reports on the SolarAIDD platform."/>
            <meta name="keywords" content="how to detect solar cracks, EL image upload guide, interpreting solar AI results, PV defect types FAQ" />
            <meta name="robots" content="index, follow" />
            <link rel="canonical" href="https://solaraidd.csir.co.za/help" />
        </Helmet>
        <Navbar links={links} isScrolled={true}/>
        <div className="container">
            <div className="title">
                <h1> Help </h1>
            </div>
            <h4> Here you can find important information a demo on how to use SolarAIDD. </h4>
            <div className="disclaimers">
                <div className="subtitle">
                    <h2> Important information and disclaimers </h2>                    
                </div>
                <h4> The system is in its initial beta-testing stage and further development and improvement is planned. </h4>
                <div className="info-box">
                    <h3> Uploading EL images </h3>
                    <div className="box">
                    <h4> A user can upload a <b>maximum of 15 batches</b> at a time. Should the user wish to upload more, older batched must be deleted first using the Delete button on the View analysis page.  </h4>
                    <h4> The system expects batches of EL images to be uploaded. The number of EL images per batch must be between <b>1-40</b>. 
                        The system also assumes that the panel is centred in the frame and no distortions or noise are present. </h4>
                    <h4> For batches containing half-cut cell modules, please enter the number of half cell rows and columns. </h4>
                    </div>
                </div> 
                <div className="info-box">
                    <h3> Upload and processing speed </h3>
                    <div className="box">
                    <h4> The system takes approximately 1min to process a single image. While a batch is being processed, you are free to view
                        any other page. Note that the system processess one batch at a time and that it will not allow you to upload another 
                        batch while the current batch is being processed. </h4>
                    </div>
                </div>      
                <div className="info-box">
                    <h3> Results pages </h3>
                    <div className="box">
                    <h4> The system takes you on a journey through the results. The first page gives a high-level overview of the previously uploaded
                        batches.  </h4>
                    </div>
                </div>       
            </div>   
            <div className="video-box">
                <div className="subtitle">
                    <h2> Demo Video </h2>
                    <h4> Please watch the video for a short demonstration on how to use the system. </h4>
                </div>                    
                <video width="100%" height="100%" controls>
                    <source src={src_video} type="video/mp4" />
                </video>
            </div>         
            <Footer/> 
        </div>
           
    </Container>
)
}

const Container = styled.div`
background: white;
.container {
    position: absolute;
    top: 7rem;
    left: 0;
    width: 100vw;
    color: black;
    background: white;
    display: flex;  
    flex-direction: column;
    align-items: center;
    gap: 2rem;
    h4 {
        font-weight: normal;
    }
    .title {
        text-align: center;
    }
    .info {
        width: 85vw;
        text-align: center;
    }
    .video-box {
        text-align: center;
        width: 30vw;
        display: flex;  
        flex-direction: column;
        align-items: center;
        justify-content: space-between;
        .subtitle {            
            padding: 0.5rem;
        }
        Video {
            max-width: 100%;
            max-height: 100%;
        }
    }
    .disclaimers {        
        width: 85vw;
        display: flex;  
        flex-direction: column;
        align-items: center;
        justify-content: space-between;
        gap: 1rem;
        
        .subtitle {            
            padding: 0.5rem 0rem;
            text-align: center;
        }
        .info-box {
            width: 85vw;
            display: flex;  
            flex-direction: column;
            align-items: center;
            justify-content: space-between;
            text-align: center;
            padding: 0.5rem;
            .box  {
                width: 80vw;
                display: flex;  
                flex-direction: column;
                align-items: left;            
                text-align: left;
                gap: 1rem;
            }
        }
    }
}
`